import { createContextHook } from '@/utils';
import { CurrentUserContext } from '../CurrentUserContext';

export const useCurrentUserContext = createContextHook(CurrentUserContext);
